import { GetListParams, GetOneParams } from 'react-admin';

export interface CustomDataProvider {
  getList: (resource: string, params: GetListParams) => Promise<any>;
  getOne?: (resource: string, params: GetOneParams) => Promise<any>;
  create?: (resource: string, params: any) => Promise<any>;
  update?: (resource: string, params: any) => Promise<any>;
  delete?: (resource: string, params: any) => Promise<any>;
}

export interface ModuleDataProviderConfig {
  resource: string;
  dataProvider: CustomDataProvider;
}

// 模块数据提供者注册表
const moduleDataProviders: Map<string, CustomDataProvider> = new Map();

/**
 * 注册模块专用的数据提供者
 * @param resource 资源名称
 * @param dataProvider 数据提供者实例
 */
export function registerModuleDataProvider(resource: string, dataProvider: CustomDataProvider) {
  moduleDataProviders.set(resource, dataProvider);
}

/**
 * 获取模块专用的数据提供者
 * @param resource 资源名称
 * @returns 数据提供者实例或 null
 */
export function getModuleDataProvider(resource: string): CustomDataProvider | null {
  return moduleDataProviders.get(resource) || null;
}

/**
 * 检查是否有模块专用的数据提供者
 * @param resource 资源名称
 * @returns 是否存在专用数据提供者
 */
export function hasModuleDataProvider(resource: string): boolean {
  return moduleDataProviders.has(resource);
}


